var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help_banner",on:{"click":_vm.onClick}},[_c('div',{staticStyle:{"flex-grow":"1"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticStyle:{"flex-grow":"0"}},[_c('v-icon',[_vm._v(" mdi-help-box-multiple-outline ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }